import * as t from 'io-ts';
import { UUID, True, False, Email } from '@thingos/io-ts-shared';
import { UserInvitationData } from '../models';
export const GetUserRequest = t.type({
    email: Email,
});
export const UserDetails = t.type({
    name: t.string,
});
export const ExistingUserResponse = t.intersection([
    t.type({ exists: True, id: UUID, email: Email }),
    t.union([
        t.type({
            userDetailsHidden: False,
            userDetails: UserDetails,
        }),
        t.type({ userDetailsHidden: True }),
    ]),
]);
export const GetUserResponse = t.union([
    t.type({
        exists: False,
    }),
    ExistingUserResponse,
]);
export const InviteAdminRequest = UserInvitationData;
export const AdminInfo = t.intersection([
    t.type({
        id: t.string,
        email: t.string,
        invitePending: t.boolean,
    }),
    t.partial({ name: t.string }),
]);
export const CheckInvitationParameter = t.type({
    invitation: UUID,
});
export const CheckInvitationResponse = t.type({
    email: t.string,
    expired: t.boolean,
});
export const RegistrationData = t.intersection([
    t.type({
        invitation: t.string,
        password: t.string,
    }),
    t.partial({ name: t.string }),
]);
export const GetAdminsResponse = t.array(AdminInfo);
export const WithPassword = t.type({
    password: t.string,
});
export const NameChangeRequest = t.type({
    name: t.string,
});
export const PasswordChangeRequest = t.intersection([
    t.type({
        newPassword: t.string,
    }),
    WithPassword,
]);
export const DeleteAccountRequest = WithPassword;
export const RemoveAdminRequest = t.intersection([WithPassword, t.type({ id: t.string })]);
export const ResetPasswordRequest = t.type({
    email: Email,
});
export const PasswordResetInfoRequest = t.type({
    token: t.string,
});
export const PasswordResetInfoResponse = t.type({
    email: t.string,
    expired: t.boolean,
});
export const PasswordResetRequest = t.type({
    token: t.string,
    password: t.string,
});
//# sourceMappingURL=users.js.map